<template>
  <div>
    <section v-if="this.error != ''">
      <error-alert :error="error" />
    </section>

    <div class="panel panel-primary">
      <div class="panel-heading PanelHeadingCaption roundedcornerdiv">
        Mortgage Deduction
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label subheaderlabel"
              >Original Mortgage Amount</label
            >
            <input
              class="form-control form-control-lg"
              :class="{
                error:
                  $v.MortgageQuestionnaire.OriginalMortgageAmount.$invalid &&
                  this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              type="text"
              v-model="$v.MortgageQuestionnaire.OriginalMortgageAmount.$model"
              v-mask="mask"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <label class="Questionniare_Label subheaderlabel"
            >Original Lender or Contract Seller</label
          >
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Date of Mortgage/Contract</label>
            <input
              class="form-control form-control-lg"
              :class="{
                error:
                  $v.MortgageQuestionnaire.DateOfMortgage.$invalid &&
                  this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              type="Text"
              v-mask="'##/##/####'"
              v-model="$v.MortgageQuestionnaire.DateOfMortgage.$model"
              placeholder="mm/dd/yyyy"
            />
          </fieldset>
        </div>
      </div>

      <div
        class="row Q_Row"
        v-if="
          $v.MortgageQuestionnaire.DateOfMortgage.$invalid &&
          this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
        "
      >
        <div class="col">
          <span class="ValidateLabel">{{
            this.MortgageValidationMessage
          }}</span>
        </div>
      </div>

      <div class="row Q_Row row-eq-height">
        <div class="col-sm-4 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label row-flex"
              >Name of Lender or Contract Seller</label
            >
            <input
              id="inputOriginalLenderOrContractSeller"
              class="form-control form-control-lg row-flex"
              :class="{
                error:
                  $v.MortgageQuestionnaire.OriginalLenderOrContractSeller
                    .$invalid &&
                  this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              type="text"
              v-model="
                $v.MortgageQuestionnaire.OriginalLenderOrContractSeller.$model
              "
              maxlength="50"
              placeholder
            />
          </fieldset>
        </div>

        <div class="col-sm-4 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label row-flex">Address 1</label>
            <input
              id="inputLenderAddress1"
              class="form-control form-control-lg row-flex"
              :class="{
                error:
                  $v.MortgageQuestionnaire.LenderAddress1.$invalid &&
                  this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              type="text"
              v-model="$v.MortgageQuestionnaire.LenderAddress1.$model"
              maxlength="30"
              placeholder
            />
          </fieldset>
        </div>

        <div class="col-sm-4 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label row-flex">Address 2</label>
            <input
              id="inputLenderAddress2"
              class="form-control form-control-lg row-flex"
              style="vertical-align: bottom !important"
              type="text"
              v-model="MortgageQuestionnaire.LenderAddress2"
              maxlength="30"
              placeholder
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Zip Code</label>
            <input
              id="inputLenderZipCode"
              class="form-control form-control-lg"
              type="text"
              v-mask="'#####'"
              v-model="MortgageQuestionnaire.LenderZipCode"
              placeholder
            />
          </fieldset>
        </div>

        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">City</label>
            <input
              id="inputLenderCity"
              class="form-control form-control-lg"
              type="text"
              :class="{
                error:
                  $v.MortgageQuestionnaire.LenderCity.$invalid &&
                  this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
              }"
              v-model="$v.MortgageQuestionnaire.LenderCity.$model"
              maxlength="25"
              placeholder
            />
          </fieldset>
        </div>

        <!--     <state-selection :State="$v.MortgageQuestionnaire.LenderState.$model"/>-->

        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">State:</label>
            <select
              v-model="$v.MortgageQuestionnaire.LenderState.$model"
              class="form-control form-control-lg statedropdown"
              :class="{
                error:
                  $v.MortgageQuestionnaire.LenderState.$invalid &&
                  this.MortgageQuestionnaire.Exemption_Questionnaire_Submitted
              }"
            >
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
          </fieldset>
        </div>
      </div>
    </div>
  </div>

  <!-- end of panel-->
</template>

<script>
import { mapGetters } from "vuex";
import VueMask from "v-mask";
import axios from "axios";

import createNumberMask from "text-mask-addons/dist/createNumberMask";

import {
  required,
  requiredIf,
  decimal,
  minValue,
  email,
  minLength
} from "vuelidate/lib/validators";

import ErrorAlert from "../components/ErrorAlert.vue";
//import StateSelection from '../components/StateSelection.vue';

const currencyMask = createNumberMask({
  prefix: "",
  allowDecimal: false,
  includeThousandsSeparator: true,
  allowNegative: false,
  integerLimit: 9
});

export function ValidateMortgageDate(Value) {
  //set default error message
  this.MortgageValidationMessage =
    "Date of Mortgage/Contract is required and must be between 01/01/1900 and the current date.";

  if (Value == undefined || Value == "") {
    return false;
  }

  var isValidDate = true;

  // First check for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(Value)) isValidDate = false;

  // Parse the date parts to integers
  var parts = Value.split("/");
  var day = parseInt(parts[1], 10);
  var month = parseInt(parts[0], 10);
  var year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month == 0 || month > 12)
    isValidDate = false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
    monthLength[1] = 29;

  // Check the range of the day
  if (day <= 0 || day > monthLength[month - 1]) isValidDate = false;

  if (!isValidDate) {
    this.MortgageValidationMessage =
      "Date of Mortgage/Contract is not a valid date.";
    return false;
  } else {
    var beginDate = new Date("01/01/1900");
    var endDate = new Date();
    var checkDate = new Date(Value);
    var isValid = Value != "" && checkDate >= beginDate && checkDate <= endDate;

    return isValid;
  }
}

export default {
  components: { ErrorAlert },
  name: "MortgageQuestionnaire",
  data: () => ({
    mask: currencyMask,
    error: "",
    MortgageValidationMessage: ""
  }),
  props: {
    MortgageQuestionnaire: {
      type: Object,
      required: true
    },
    v: {
      type: Object,
      required: true
    },
    CorpCode: {
      type: String,
      required: true
    }
  },
  watch: {
    "MortgageQuestionnaire.LenderZipCode": function (val, preVal) {
      if (val.length == 5) {
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "ZipCode?ZipCode=" +
              val +
              "&CorpCode=" +
              this.CorpCode
          )
          .then((response) => {
            this.MortgageQuestionnaire.LenderState = response.data[0].state;
            this.MortgageQuestionnaire.LenderCity = response.data[0].city;
          })
          .catch((e) => {
            this.error = "Error Retrieving Zip Code Lookup: " + e;
          });
      }
    }
  },
  validations: {
    MortgageQuestionnaire: {
      LenderState: {
        required
      },
      OriginalMortgageAmount: {},
      OriginalLenderOrContractSeller: {
        required
      },
      LenderAddress1: {
        //required
      },
      LenderCity: {
        //required
      },
      LenderState: {
        //  required
      },
      DateOfMortgage: {
        ValidateMortgageDate
      },
      PhoneNumber: {
        required
      },
      EmailAddress: {
        required
      }
    }
  }
};
</script>
